export const gestionPialVersion = {
  branch: 'production',
  hash: '9ce50b8a',
  fullHash: '9ce50b8a9c87926dff8c19bffc15de6d077740f9',
  date: '2026-10-01T17:04:32+02:00',
};
